import { HallAvatar } from '$common/avatar'
import { ChannelIcon, GroupIcon } from '$common/icons'
import { MenuIcon } from '$common/icons/menu'
import { nothing } from '$func/utils'
import { useRoom } from '$logic/room/react-hook'
import { useHall } from '$logic/hall/react-hook'
import { ChatListItem } from '../chat-list-item'
import { HallStatus } from './hall-status'
import { HallListItemTitle } from './hall-list-item-title'
import { AvatarSize } from '$common/avatar/avatar-base/types'

interface Props {
  chatId: string
  hasDivider?: boolean
  onClick?: () => unknown
  onContextMenu?: (e: Event) => void
  onSecondaryActionIconClick?: () => unknown
  selected?: boolean
}

export function HallListItemWithStatus({
  chatId,
  hasDivider = true,
  onClick = nothing,
  onSecondaryActionIconClick = nothing,
  onContextMenu = nothing,
  selected = false,
}: Props) {
  const { type } = useRoom(chatId) || {}
  const { entity: hall } = useHall(chatId)

  const primaryTextIcon =
    type === 'CHANNEL' ? (
      <ChannelIcon
        sx={{ color: 'primary.main', width: '20px', height: '20px' }}
      />
    ) : type === 'GROUP' ? (
      <GroupIcon
        sx={{ color: 'primary.main', width: '20px', height: '20px' }}
      />
    ) : (
      undefined
    )

  return (
    <ChatListItem
      avatarComponent={
        <HallAvatar
          selected={selected}
          roomId={chatId}
          size={AvatarSize.MD}
          withStory
        />
      }
      primaryTextIcon={primaryTextIcon}
      primaryText={<HallListItemTitle hallId={chatId} />}
      secondaryText={<HallStatus hallId={chatId} />}
      SecondaryActionIcon={MenuIcon}
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
      verified={hall?.verified}
    />
  )
}
